export default "__VITE_ASSET__BrY_Bi5s__"